<template>
  <ms-combobox
    value-field="value"
    display-field="display"
    :data="propsData.comboboxValues"
    @selected="selected"
    :init-text="initText"
    :rules="[]"
  >
  </ms-combobox>
</template>

<script>
import {computed, ref} from 'vue';
export default {
  name: 'toolbarItemCombobox',
  props: {
    propsData: {
      type: Object,
      default: {},
    },
    rangeStyle: {
      type: Object,
      default: {},
    },
  },
  emits: ['toolbarEvent'],
  setup(props, {emit}) {
    const initText = computed(() => {
      let comboboxValues = props.propsData.comboboxValues;
      if (comboboxValues?.length > 0) {
        let text = comboboxValues.find(x => x.value == props.rangeStyle[props.propsData.styleName])?.display;
        return text;
      }
      return '';
    });
    /**
     * Hàm trả ra giá trị vừa chọn
     * TMNghia 30/03/2024
     */
    const selected = metaData => {
      emit('toolbarEvent', event, 'selected', {toolbar: props.propsData, value: metaData});
    };

    return {
      selected,
      initText,
    };
  },
};
</script>

<style>
</style>